import { useMemo } from 'react'
import { SchemaEditorBody } from '@/components/schema/SchemaEditorBody'
import { SchemaElementDialogs } from '@/components/schema/SchemaElementDialogs'
import { useSchemaManager } from '@/features/schema/hooks/useSchemaManager'
import {
  useSchemaValidation,
  useValidateSavedSchema,
} from '@/features/schema/hooks/useSchemaValidation'
import type { SchemaSession } from '@/services/api/schemaSessions'

export function DraftSchemaEditor({
  session,
  onChange,
  readOnly,
}: {
  session: SchemaSession
  onChange: (session: SchemaSession) => void
  readOnly: boolean
}) {
  const schema = session.workingSchema ?? session.draft
  const context = useMemo(
    () =>
      schema
        ? {
            caseId: session.caseId,
            draft: { sessionId: session.id, schema, onChange },
          }
        : undefined,
    [session.caseId, session.id, schema, onChange]
  )
  const sm = useSchemaManager(context)
  const validation = useSchemaValidation()
  useValidateSavedSchema(sm.lastSavedSchema, validation.validate)
  if (!schema) return null
  return (
    <>
      <SchemaEditorBody
        sm={sm}
        schema={sm.selectedSchema ?? schema}
        validation={validation}
        editing={{ readOnly }}
      />
      <SchemaElementDialogs sm={sm} schema={sm.selectedSchema ?? schema} />
    </>
  )
}
